import moment from "moment";
import { ROLES_TAB } from "../../framework/tab/tabUtilsConstants";

export const privilege_groups = [
  {
    groupId: "SALES",
    groupLabel: "Sales",
    privileges: [
      {
        id: "SALES_CREATE",
        label: "Create",
        desc: "Allows the user to create new sales transactions",
      },
      {
        id: "SALES_EDIT",
        label: "Edit",
        desc: "Allows the user to edit sales transactions",
      },
      {
        id: "SALES_DELETE",
        label: "Delete",
        desc: "Allows the user to delete sales transactions",
      },
      {
        id: "SALES_VIEW",
        label: "View",
        desc: "Read all sales transactions",
      },
      {
        id: "BATCH_CREATE",
        label: "Add New Batch",
        desc: "Allows the user to add new batch for the selected product",
      },
      {
        id: "SALES_EDIT_PRODUCTS",
        label: "Edit Product details",
        desc: "Allows the user to edit product details",
      },
      {
        id: "SALES_BILL_REPRINT",
        label: "Bill Re-Printing",
        desc: "Allows the user to print duplicate sales bills from report",
      },
      {
        id: "REPORT_HOME_DELIVERY",
        label: "Home Delivery",
        desc: "Allows the user to manage home delivery orders",
      },
      {
        id: "SCHEDULE_ORDER_CREATE",
        label: "Create Schedule Order",
        desc: "Allows the user to create new schedule orders",
      },
      {
        id: "SCHEDULE_ORDER_VIEW",
        label: "Schedule Order Report",
        desc: "Allows the user to manage schedule orders",
      },
      {
        id: "EDITED_SALES_REPORT",
        label: "Edited Sales Bill",
        desc: "Allows the user to view the history of edited sales bills",
      },
    ],
  },
  {
    groupId: "SALES_B2B",
    groupLabel: "Sales B2B",
    privileges: [
      {
        id: "SALES_B2B_CREATE",
        label: "Create",
        desc: "Allows the user to create new sales b2b transactions",
      },
      {
        id: "SALES_B2B_EDIT",
        label: "Edit",
        desc: "Allows the user to edit sales b2b transactions",
      },
      {
        id: "SALES_B2B_VIEW",
        label: "View",
        desc: "Read all sales b2b transactions",
      },
      {
        id: "SALES_B2B_DELETE",
        label: "Delete",
        desc: "Delete sales b2b transactions",
      },
    ],
  },
  {
    groupId: "SALES_B2B_RETURN",
    groupLabel: "Sales B2B Return",
    privileges: [
      {
        id: "SALES_B2B_RETURN_CREATE",
        label: "Create",
        desc: "Allows the user to create new sales b2b return transactions",
      },
      {
        id: "SALES_B2B_RETURN_EDIT",
        label: "Edit",
        desc: "Allows the user to edit sales b2b return transactions",
      },
      {
        id: "SALES_B2B_RETURN_DELETE",
        label: "Delete",
        desc: "Allows the user to delete sales b2b return transactions",
      },
      {
        id: "SALES_B2B_RETURN_VIEW",
        label: "View",
        desc: "Read all sales b2b return transactions",
      },
    ],
  },
  {
    groupId: "PURCHASE",
    groupLabel: "Purchase",
    privileges: [
      {
        id: "PURCHASE_VIEW",
        label: "View",
        desc: "Read all purchase transactions",
      },
      {
        id: "PURCHASE_CREATE",
        label: "Create",
        desc: "Allows the user to create new purchase transactions",
      },
      {
        id: "PURCHASE_DELETE",
        label: "Delete",
        desc: "Allows the user to delete purchase transactions",
      },
      {
        id: "PURCHASE_EDIT",
        label: "Edit",
        desc: "Allows the user to edit purchase transactions",
      },
      {
        id: "PURCHASE_PRINT_BARCODE",
        label: "Print Barcode",
        desc: "Allows the users to print Barcodes explicitly",
      },
      {
        id: "PURCHASE_EMAILS",
        label: "Emails",
        desc: "Read and process emails",
      },
      {
        id: "APO_CREATE",
        label: "Auto Place Order (APO)",
        desc: "Allows the users to create auto purchase orders",
      },
      {
        id: "APO_VIEW",
        label: "Auto Placed Order Report",
        desc: "Allows the users to view auto purchase orders",
      },
      {
        id: "CHALLAN_VIEW",
        label: "Challan Report",
        desc: "Allows the users to view challans",
      },
      {
        id: "DATE_WISE_PURCHASE_REPORT",
        label: "Date Wise Purchase Report",
        desc: "Allows the users to view date wise purchase report",
      },
    ],
  },
  {
    groupId: "SHORT_BOOK",
    groupLabel: "Short Book",
    privileges: [
      {
        id: "DEMAND_BOOK_CREATE",
        label: "Create",
        desc: "Allows the user to create new shortbook entries",
      },
      {
        id: "DEMAND_BOOK_EDIT", //Not present in PharmacyPro Roles & Permissions Setting for DMart File
        label: "Edit",
        desc: "Allows the user to edit shortbook entries",
      },
      {
        id: "DEMAND_BOOK_DELETE",
        label: "Delete",
        desc: "Allows the user to delete shortbook entries",
      },
      {
        id: "DEMAND_BOOK_VIEW",
        label: "View",
        desc: "Allows the user to view shortbook entries",
      },
    ],
  },
  {
    groupId: "PROMISE_ORDER",
    groupLabel: "Promise Order",
    privileges: [
      {
        id: "PROMISE_ORDER_CREATE",
        label: "Create",
        desc: "Allows the user to create new promise order entries",
      },
      {
        id: "PROMISE_ORDER_EDIT", //Not present in PharmacyPro Roles & Permissions Setting for DMart File
        label: "Edit",
        desc: "Allows the user to edit promise order entries",
      },
      {
        id: "PROMISE_ORDER_DELETE",
        label: "Delete",
        desc: "Allows the user to delete promise order entries",
      },
      {
        id: "PROMISE_ORDER_RESOLVE",
        label: "Resolve",
        desc: "Allows the user to resolve existing promise order",
      },
      {
        id: "PROMISE_ORDER_VIEW",
        label: "View",
        desc: "Allows the user to view promise order entries",
      },
      {
        id: "REPORTS_PROMISE_ORDER",
        label: "Promise Order Report",
        desc: "Allows the user to view promise order report",
      },
    ],
  },
  {
    groupId: "SALES_RETURN",
    groupLabel: "Sales return",
    privileges: [
      {
        id: "SALES_RETURN_CREATE",
        label: "Create",
        desc: "Allows the user to create new sales return transactions",
      },
      {
        id: "SALES_RETURN_EDIT",
        label: "Edit",
        desc: "Allows the user to edit sales return transactions",
      },
      {
        id: "SALES_RETURN_DELETE",
        label: "Delete",
        desc: "Allows the user to delete sales return transactions",
      },
      {
        id: "SALES_RETURN_VIEW",
        label: "View",
        desc: "Read all sales return transactions",
      },
    ],
  },
  {
    groupId: "PURCHASE_RETURN",
    groupLabel: "Purchase return",
    privileges: [
      {
        id: "PURCHASE_RETURN_CREATE",
        label: "Create",
        desc: "Allows the user to create new purchase return transactions",
      },
      {
        id: "PURCHASE_RETURN_EDIT",
        label: "EDIT",
        desc: "Edit all purchase return transactions",
      },
      {
        id: "PURCHASE_RETURN_DELETE",
        label: "Delete",
        desc: "Allows the user to delete purchase return transactions",
      },
      {
        id: "PURCHASE_RETURN_VIEW",
        label: "View",
        desc: "Read all purchase return transactions",
      },
    ],
  },
  {
    groupId: "DISTRIBUTOR_PAYMENT",
    groupLabel: "Distributor Payment",
    privileges: [
      {
        id: "DISTRIBUTOR_PAYMENTS_CREATE",
        label: "Create",
        desc: "Allows the user to create new distributor payment transactions",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_EDIT",
        label: "EDIT",
        desc: "Allows the user to edit distributor payment transactions",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_DELETE",
        label: "Delete",
        desc: "Allows the user to delete distributor payment transactions",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_VIEW",
        label: "View",
        desc: "Read all distributor payment transactions",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_BILL_REPRINT",
        label: "Bill Re-printing",
        desc: "Allow user to print duplicate payment bill from reports.",
      },
    ],
  },
  {
    groupId: "PATIENT_PAYMENT",
    groupLabel: "Patient Payment",
    privileges: [
      {
        id: "PATIENT_PAYMENT_CREATE",
        label: "Create",
        desc: "Allows the user to create new patient payment transactions",
      },
      {
        id: "PATIENT_PAYMENT_EDIT",
        label: "EDIT",
        desc: "Allows the user to edit patient payment transactions",
      },
      {
        id: "PATIENT_PAYMENT_DELETE",
        label: "Delete",
        desc: "Allows the user to delete patient payment transactions",
      },
      {
        id: "PATIENT_PAYMENT_VIEW",
        label: "View",
        desc: "Read all patient payment transactions",
      },
      {
        id: "PATIENT_PAYMENT_SHOW_BANK_TXN",
        label: "Allow Bank transactions",
        desc: "Allows user to accept bank txn like Cheque, RTGS, IMPS, NEFT",
      },
      {
        id: "PATIENT_PAYMENT_BILL_REPRINT",
        label: "Bill Re-printing",
        desc: "Allow user to print duplicate payment bill from reports.",
      },
    ],
  },
  {
    groupId: "CUSTOMER_PAYMENTS",
    groupLabel: "Customer Payments",
    privileges: [
      {
        id: "CUSTOMER_PAYMENTS_CREATE",
        label: "Create",
        desc: "Allows the user to create new customer payment transactions",
      },
      {
        id: "CUSTOMER_PAYMENTS_EDIT",
        label: "Edit",
        desc: "Allows the user to edit customer payment transactions",
      },
      {
        id: "CUSTOMER_PAYMENTS_DELETE",
        label: "Delete",
        desc: "Allows the user to delete customer payment transactions",
      },
      {
        id: "CUSTOMER_PAYMENTS_VIEW",
        label: "View",
        desc: "Read all customer payment transactions",
      },
      {
        id: "CUSTOMER_PAYMENTS_TXN_VIEW",
        label: "Customer Payment Txn",
        desc: "View and export customer payment transaction invoice wise",
      },
      {
        id: "CUSTOMER_PAYMENTS_PRINT",
        label: "Print",
        desc: "Allows the user to print customer payment bills",
      },
      {
        id: "CUSTOMER_PAYMENTS_BILL_REPRINT",
        label: "Bill Re-printing",
        desc: "Allow user to print duplicate customer payment bill from reports",
      },
    ],
  },
  {
    groupId: "B2B_RETURN_PAYMENTS",
    groupLabel: "B2B Return Payments",
    privileges: [
      {
        id: "B2B_RETURN_PAYMENTS_CREATE",
        label: "Create",
        desc: "Allows the user to create new b2b return payment transactions",
      },
      {
        id: "B2B_RETURN_PAYMENTS_EDIT",
        label: "Edit",
        desc: "Allows the user to edit b2b return payment transactions",
      },
      {
        id: "B2B_RETURN_PAYMENTS_DELETE",
        label: "Delete",
        desc: "Allows the user to delete b2b return payment transactions",
      },
      {
        id: "B2B_RETURN_PAYMENTS_VIEW",
        label: "View",
        desc: "Read all b2b return payment transactions",
      },
      {
        id: "B2B_RETURN_PAYMENTS_PRINT",
        label: "Print",
        desc: "Allows the user to print b2b return payment bills",
      },
    ],
  },
  {
    groupId: "ACCOUNTING",
    groupLabel: "Accounting",
    privileges: [
      {
        id: "ACCOUNTING_CREATE",
        label: "Create Voucher",
        desc: "Allows the user to create new voucher transactions",
      },
      {
        id: "ACCOUNTING_EDIT",
        label: "Edit Voucher",
        desc: "Allows the user to edit voucher transactions",
      },
      {
        id: "ACCOUNTING_DELETE",
        label: "Delete Voucher",
        desc: "Allows the user to delete voucher transactions",
      },
      {
        id: "ACCOUNTING_VIEW",
        label: "View Voucher",
        desc: "Read all voucher transactions",
      },
      {
        id: "ACCOUNTING_CHARTS_OF_ACCOUNT",
        label: "View Charts of Account",
        desc: "Allows the user to view all accounts",
      },
      {
        id: "ACCOUNTING_LEDGER_DETAILS",
        label: "View Ledger Details",
        desc: "Allows the user to view all ledgers",
      },
      {
        id: "DISTRIBUTOR_ACCOUNTING_LEDGER_DETAILS",
        label: "View Distributor Ledger Details",
        desc: "Allows the user to view distributor ledger details",
      },
      {
        id: "ACCOUNTING_TRIAL_BALANCE",
        label: "View Trial Balance Report",
        desc: "Allows the user to view and export the report",
      },
      {
        id: "ACCOUNTING_PROFIT_AND_LOSS",
        label: "View Profit and Loss Report",
        desc: "Allows the user to view and export the report",
      },
      {
        id: "ACCOUNTING_STANDARD_PROFIT_AND_LOSS",
        label: "View Standard Profit and Loss Report",
        desc: "Allows the user to view and export the report",
      },
      {
        id: "ACCOUNTING_GSTR",
        label: "GSTR Report",
        desc: "Allows the user to export the GSTR reports",
      },
      {
        id: "ACCOUNTING_GST_SUMMARY",
        label: "GSTR Summary Report",
        desc: "Allows the user to view and export the GST summary report",
      },
    ],
  },
  {
    groupId: "USER",
    groupLabel: "User",
    privileges: [
      {
        id: "ACCESS_CONTROL_CREATE",
        label: "Create",
        desc: "Allows the user to create new users",
      },
      {
        id: "ACCESS_CONTROL_EDIT",
        label: "Edit",
        desc: "Allows the user to edit users",
      },
      {
        id: "ACCESS_CONTROL_DELETE",
        label: "Delete",
        desc: "Allows the user to delete users",
      },
      {
        id: "ACCESS_CONTROL_VIEW",
        label: "View",
        desc: "Allows the user to view users",
      },
      {
        id: "SALES_DELIVERY_AGENT",
        label: "Sales Delivery Agent",
        desc: "Assigns the user as delivery agent",
      },
    ],
  },
  {
    groupId: "ROLES",
    groupLabel: "Roles",
    privileges: [
      {
        id: "ROLES_CREATE",
        label: "Create",
        desc: "Allows the user to create new roles",
      },
      {
        id: "ROLES_EDIT",
        label: "Edit",
        desc: "Allows the user to edit roles",
      },
      {
        id: "ROLES_DELETE",
        label: "Delete",
        desc: "Allows the user to delete roles",
      },
      {
        id: "ROLES_VIEW",
        label: "View",
        desc: "Allows the user to view roles",
      },
    ],
  },
  {
    groupId: "CONFIGURATION",
    groupLabel: "Configuration",
    privileges: [
      {
        id: "CONFIGURATION_VIEW",
        label: "View/Edit",
        desc: "Allows the user to view/edit roles",
      },
    ],
  },
  {
    groupId: "MASTER",
    groupLabel: "Master",
    privileges: [
      {
        id: "PATIENT_CREATE",
        label: "Add New Patient",
        desc: "Allows the user to add new patient",
      },
      {
        id: "PATIENT_EDIT",
        label: "Edit Patient",
        desc: "Allows the user to edit patient details",
      },
      {
        id: "PATIENT_DELETE",
        label: "Delete Patient",
        desc: "Allows the user to delete patient ",
      },
      {
        id: "PATIENT_VIEW",
        label: "View Patient Master",
        desc: "Allows the user to view and export patient master",
      },
      {
        id: "PATIENT_REMAP",
        label: "Merge Patient",
        desc: "Allows the user to merge two patients",
      },
      {
        id: "DOCTOR_CREATE",
        label: "Add New Doctor",
        desc: "Allows the user to add new doctor",
      },
      {
        id: "DOCTOR_EDIT",
        label: "Edit Doctor",
        desc: "Allows the user to edit doctor details",
      },
      {
        id: "DOCTOR_DELETE",
        label: "Delete Doctor",
        desc: "Allows the user to delete doctor",
      },
      {
        id: "DOCTOR_VIEW",
        label: "View Doctor Master",
        desc: "Allows the user to view and export doctor master",
      },
      {
        id: "DISTRIBUTOR_CREATE",
        label: "Add New Distributor",
        desc: "Allows the user to add new distributor",
      },
      {
        id: "DISTRIBUTOR_EDIT",
        label: "Edit Distributor",
        desc: "Allows the user to edit distributor details",
      },
      {
        id: "DISTRIBUTOR_DELETE",
        label: "Delete Distributor",
        desc: "Allows the user to distributor doctor ",
      },
      {
        id: "DISTRIBUTOR_VIEW",
        label: "View Distributor",
        desc: "Allows the user to view and export distributor master",
      },
      {
        id: "DISTRIBUTOR_REMAP",
        label: "Merge Distributor",
        desc: "Allows the user to merge two distributors",
      },
      {
        id: "MEDICINE_CREATE",
        label: "Add New Product",
        desc: "Allows the user to add new product",
      },
      {
        id: "MEDICINE_EDIT",
        label: "Edit Product",
        desc: "Allows the user to edit product details",
      },
      {
        id: "MEDICINE_VIEW",
        label: "View Product",
        desc: "Allows the user to view and export product master",
      },
      {
        id: "MEDICINE_REMAP",
        label: "Merge Product",
        desc: "Allows the user to merge two products",
      },
      {
        id: "REPORT_ITEM_GROUP",
        label: "View Item Group Master",
        desc: "Allows the user to view and export item group report",
      },
      {
        id: "ITEM_GROUP_EDIT",
        label: "Edit Item Group",
        desc: "Allow users to edit item group",
      },
      {
        id: "ITEM_GROUP_DELETE",
        label: "Delete Item Group",
        desc: "Allow users to delete item group",
      },
      {
        id: "REPORT_SERVICE_ITEM_MASTER",
        label: "View Service Item Master",
        desc: "View and export service item master report",
      },
      {
        id: "SERVICE_ITEM_DELETE",
        label: "Delete Service Item",
        desc: "Allow users to delete service item",
      },
      {
        id: "SERVICE_ITEM_EDIT",
        label: "Edit Service Item",
        desc: "Allow users to edit service item",
      },
      {
        id: "REPORT_BANK_MASTER",
        label: "Bank account master",
        desc: "Allow users to view and export bank account master",
      },
      {
        id: "BANK_CREATE",
        label: "Bank account create",
        desc: "Allow users to create bank account",
      },
      {
        id: "BANK_EDIT",
        label: "Bank account edit",
        desc: "Allow users to edit bank account details",
      },
      {
        id: "CUSTOMER_CREATE",
        label: "Add New Customer",
        desc: "Allows the user to add new customer",
      },
      {
        id: "CUSTOMER_EDIT",
        label: "Edit Customer",
        desc: "Allows the user to edit customer details",
      },
      {
        id: "CUSTOMER_VIEW",
        label: "View Customer Master",
        desc: "Allows the user to view customer details",
      },
    ],
  },
  {
    groupId: "CUSTOMER_CATEGORY",
    groupLabel: "Customer Category",
    privileges: [
      {
        id: "REPORT_CUSTOMER_CATEGORY",
        label: "Customer Category Report",
        desc: "Allows the user to view and export customer category report",
      },
      {
        id: "CUSTOMER_CATEGORY_EDIT",
        label: "Edit",
        desc: "Allows the user to edit customer category",
      },
      {
        id: "CUSTOMER_CATEGORY_DELETE",
        label: "Delete",
        desc: "Allows the user to delete customer category",
      },
      {
        id: "CUSTOMER_CATEGORY_SET_ACTIVE",
        label: "Set Active",
        desc: "Allows the user to set customer category as active or inactive",
      },
    ],
  },
  {
    groupId: "SCHEME_MASTER",
    groupLabel: "Scheme Master",
    privileges: [
      {
        id: "REPORT_SCHEME_MASTER",
        label: "Scheme Master Report",
        desc: "Allows the user to view and export scheme master report",
      },
      {
        id: "SCHEME_MASTER_EDIT",
        label: "Edit",
        desc: "Allows the user to edit scheme master",
      },
      {
        id: "SCHEME_MASTER_DELETE",
        label: "Delete",
        desc: "Allows the user to delete scheme master",
      },
      {
        id: "SCHEME_MASTER_SET_ACTIVE",
        label: "Set Active",
        desc: "Allows the user to set scheme master as active or inactive",
      },
    ],
  },
  {
    groupId: "B2B_MAPPING",
    groupLabel: "B2B Mapping",
    privileges: [
      {
        id: "REPORT_B2B_MAPPING",
        label: "B2B Mapping Report",
        desc: "Allows the user to view and export b2b mapping report",
      },
      {
        id: "B2B_MAPPING_VIEW",
        label: "View",
        desc: "Allows the user to view b2b mapping details",
      },
      {
        id: "B2B_MAPPING_CREATE",
        label: "Create",
        desc: "Allows the user to create new b2b mapping",
      },
      {
        id: "B2B_MAPPING_EDIT",
        label: "Edit",
        desc: "Allows the user to edit b2b mapping",
      },
      {
        id: "B2B_MAPPING_SET_ACTIVE",
        label: "Set Active",
        desc: "Allows the user to set b2b mapping as active or inactive",
      },
    ],
  },
  {
    groupId: "STOCK",
    groupLabel: "Stock",
    privileges: [
      {
        id: "BATCH_ADJUST_STOCK",
        label: "Stock Adjustment",
        desc: "Allows the user to adjust the stock in batch stock report",
      },
      {
        id: "AUDITING_CREATE",
        label: "Stock Audit",
        desc: "Allows the user to create new stock audit",
      },
      {
        id: "AUDITING_VIEW",
        label: "Stock Audit Report",
        desc: "Allows the user to view stock audit entries",
      },
      {
        id: "REPORT_STOCK_AUDIT_DETAILS",
        label: "Stock Audit Details Report",
        desc: "View and export product wise stock audit report",
      },
      {
        id: "REPORT_CONSOLIDATED_STOCK_AUDIT_DETAILS",
        label: " Consolidated Stock Audit Report",
        desc: "View and Export the consolidated stock audit report",
      },
      {
        id: "OPENING_STOCK_CREATE",
        label: "Opening Stock",
        desc: "Allows the user to create opening stock entries",
      },
      {
        id: "OPENING_STOCK_VIEW",
        label: "Opening Stock Report",
        desc: "Allows the user to view opening stock report",
      },
    ],
  },
  {
    groupId: "DASHBOARD",
    groupLabel: "Dashboard",
    privileges: [
      {
        id: "DASHBOARD_VIEW_SALES",
        label: "Dashboard-Sales",
        desc: "Allows the user to view sales dashboard",
      },
      {
        id: "DASHBOARD_VIEW_PURCHASE",
        label: "Dashboard-Purchase",
        desc: "Allows the user to view purchase dashboard",
      },
      {
        id: "DASHBOARD_VIEW_STOCK",
        label: "Dashboard-Stock",
        desc: "Allows the user to view dashboard",
      },
      {
        id: "DASHBOARD_VIEW_PAYMENTS",
        label: "Dashboard-Payments",
        desc: "Allows the user to view dashboard",
      },
    ],
  },
  {
    groupId: "SHIFT_MANAGEMENT",
    groupLabel: "Shift Management",
    privileges: [
      {
        id: "SHIFT_MANAGEMENT_CREATE",
        label: "Allow Shift",
        desc: "Allows the user to create and close shifts",
      },
      {
        id: "SHIFT_MANAGEMENT_SUMMARY",
        label: "Shift Summary Report",
        desc: "Allows the user to view user wise shift summary report",
      },
      {
        id: "SHIFT_MANAGEMENT_SHOWALL",
        label: "Show All Shifts",
        desc: "Allows the user to view all users shift summary report",
      },
      {
        id: "SHIFT_MANAGEMENT_REVIEW",
        label: "Approve Shift Denominations",
        desc: "Allows the user to approve shift cash denominations",
      },
      {
        id: "SHIFT_MANAGEMENT_EDIT",
        label: "Edit Shift Denominations",
        desc: "Allows the user to edit shift cash denominations",
      },
      {
        id: "SHIFT_MANAGEMENT_DAY_END",
        label: "Perform Day End",
        desc: "Allows the user to day end shifts",
      },
      {
        id: "REPORT_DAY_END",
        label: "Edit Day End Activity",
        desc: "Allows the user to undo day end activity",
      },
    ],
  },
  {
    groupId: "DISCOUNT_PROGRAM",
    groupLabel: "Discount Program",
    privileges: [
      {
        id: "DISCOUNT_PROGRAM_CREATE",
        label: "Create Discount Program",
        desc: "Allows the user to create discount program",
      },
      {
        id: "DISCOUNT_PROGRAM_EDIT",
        label: "Edit Discount Program",
        desc: "Allows the user to edit discount program",
      },
      {
        id: "DISCOUNT_PROGRAM_DELETE",
        label: "Delete Discount Program",
        desc: "Allows the user to delete discount program",
      },
      {
        id: "REPORTS_DISCOUNT_PROGRAM",
        label: "Discount Program Report",
        desc: "Allows the user to view discount program report",
      },
    ],
  },
  {
    groupId: "REPORTS",
    groupLabel: "Reports",
    privileges: [
      {
        id: "REPORT_BATCH_STOCK",
        label: "Batch Stock",
        desc: "Allows the user to view and export batch stock report",
      },
      {
        id: "REPORT_MEDICINE_STOCK",
        label: "Product Stock",
        desc: "Allows the user to view and export product stock report",
      },
      {
        id: "REPORT_TRANSACTION",
        label: "Transaction Report",
        desc: "Allows the user to view and export trasnaction stock report",
      },
      {
        id: "REPORT_STOCK_ADJUSTMENT",
        label: "Stock Adjustment Report",
        desc: "Allows the user to view and export stock adjustment report",
      },
      {
        id: "REPORT_CREDIT_NOTE_TRACKING",
        label: "Credit Note Tracking",
        desc: "Allows the user to view and export credit note report",
      },
      {
        id: "REPORT_EXPIRY_ALERT",
        label: "Expiry Alert Report",
        desc: "Allows the user to view and export near expiry and expired stock report",
      },
      {
        id: "REPORT_MEDICINE_WISE_SALES",
        label: "Sales By Product",
        desc: "Allows the user to view and export product wise sales report",
      },
      {
        id: "REPORT_MEDICINE_WISE_SALES_RETURN",
        label: "Sales Return By Product",
        desc: "Allows the user to view and export product wise sales return report",
      },
      {
        id: "REPORT_MEDICINE_WISE_B2B_SALES_RETURN",
        label: "B2B Sales Return By Product",
        desc: "Allows the user to view and export product wise b2b sales return report",
      },
      {
        id: "REPORT_MEDICINE_WISE_PURCHASE",
        label: "Purchase By Product",
        desc: "Allows the user to view and export product wise purchase report",
      },
      {
        id: "REPORT_MEDICINE_WISE_PURCHASE_RETURN",
        label: "Purchase Return By Product",
        desc: "Allows the user to view and export product wise purchase return report",
      },
      {
        id: "REPORT_HSN_WISE_SALES",
        label: "HSN Wise Sales",
        desc: "Allows the user to view and export HSN wise product sales report",
      },
      {
        id: "REPORT_HSN_WISE_PURCHASE",
        label: "HSN Wise Purchase",
        desc: "Allows the user to view and export HSN wise product purchase report",
      },
      {
        id: "REPORT_GST_SALES",
        label: "GST Sales",
        desc: "View and export GST breakdowns for sales transactions",
      },
      {
        id: "REPORT_GST_PURCHASE",
        label: "GST Purchase",
        desc: "View and export GST breakdowns for purchase transactions",
      },
      {
        id: "REPORT_GST_SALES_RETURN",
        label: "GST Sales Return",
        desc: "View and export GST breakdowns for sales return transactions",
      },
      {
        id: "REPORT_GST_PURCHASE_RETURN",
        label: "GST Purchase Return",
        desc: "View and export GST breakdowns for purchase return transactions",
      },
      {
        id: "REPORT_INVOICE_WISE_TB",
        label: "TB Report Invoice Wise",
        desc: "View and export Invoice Wise TB report",
      },
      {
        id: "REPORT_MEDICINE_WISE_TB",
        label: "TB Report Product Wise",
        desc: "View and export Product Wise TB report",
      },
      {
        id: "REPORT_SCHEDULED_DRUG_SALES",
        label: "Scheduled Drug Sales Report",
        desc: "View and export schduled drug sales report",
      },
      {
        id: "REPORT_SCHEDULED_DRUG_STOCK",
        label: "Scheduled Drug Stock Report",
        desc: "View and export scheduled drug stock report",
      },
      {
        id: "PATIENT_PAYMENT_TXN_VIEW",
        label: "Customer Payment Txn",
        desc: "View and export cust. payment transaction. Provides cash,card,upi breakup of sales invoices",
      },
      {
        id: "DISTRIBUTOR_PAYMENTS_TXN_VIEW",
        label: "Distributor Payment Txn",
        desc: "View and export distributor payment transaction invoice wise.",
      },
      {
        id: "REPORT_DATE_WISE_SALES",
        label: "Date Wise Sales",
        desc: "View and export daily/date wise sales",
      },
      {
        id: "REPORT_CATEGORY_WISE_STOCK",
        label: "Category Wise Stock Report",
        desc: "View and export category wise stock report",
      },
      {
        id: "REPORT_SALES_STAGE_ORDER",
        label: "Stage Order Report",
        desc: "View and export stage order report",
      },
      {
        id: "SALES_SHOW_ALL_STAGE_BILL",
        label: "Show All Stage Orders",
        desc: "Allows the user to view stage orders from all users",
      },
      {
        id: "ACCOUNTING_GST_TALLY_EXPORT",
        label: "Tally Export Report",
        desc: "Export accounting data for Tally",
      },
      {
        id: "REPORT_VIEW_SUMMARY",
        label: "View Summary and Export",
        desc: "Allows the user to view summary and export the reports",
      },
      {
        id: "REPORT_PRODUCT_LEDGER",
        label: "Date Wise Product Ledger Report",
        desc: "View and export date wise product ledger report",
      },
      {
        id: "REPORT_SALES_VS_STOCK",
        label: "Product Sales vs Stock in Hand Report",
        desc: "View and export product wise sales vs stock in hand report",
      },
      {
        id: "REPORT_TOP_SELLING_PRODUCT",
        label: "Top Selling Product Report",
        desc: "View and export top selling product report",
      },
      {
        id: "REPORT_LOW_SELLING_PRODUCT",
        label: "Low Selling Product Report",
        desc: "View and export low selling product report",
      },
      {
        id: "REPORT_MONTH_WISE_SALES_SUMMARY",
        label: "Month Wise Sales Report",
        desc: "View and export month wise sales report",
      },
      {
        id: "REPORT_SHIFT_HOUR_WISE_SALES",
        label: "Hourly Sales Report",
        desc: "View and export hourly sales report",
      },
      {
        id: "REPORT_GST_SALES_B2B",
        label: "GST Sales B2B Report",
        desc: "View and export GST sales b2b report",
      },
      {
        id: "CHANGE_MANAGEMENT_REPORT",
        label: "Change Management Report",
        desc: "View and export change management report",
      },
      {
        id: "PATIENT_PAYMENT_ALERT_REPORT",
        label: "Patient Payment Alert Report",
        desc: "View and export patient payment alert report",
      },
      {
        id: "DISTRIBUTOR_PAYMENT_ALERT_REPORT",
        label: "Distributor Payment Alert Report",
        desc: "View and export distributor payment alert report",
      },
      {
        id: "REPORT_REFILL_ORDER",
        label: "Refill Order Report",
        desc: "View and export refill order report",
      },
      {
        id: "REPORT_PRODUCT_LEDGER_DATE_WISE",
        label: "Product Ledger Date Wise Report",
        desc: "View and export product ledger date wise report",
      },
      {
        id: "REPORTS_PROMISE_ORDER",
        label: "Promise Order Report",
        desc: "View and export promise order report",
      },
      {
        id: "REPORT_HSN_PURCHASE_SUMMARY",
        label: "HSN Purchase Summary Report",
        desc: "View and export HSN purchase summary report",
      },
      {
        id: "REPORT_HSN_SALES_SUMMARY",
        label: "HSN Sales Summary Report",
        desc: "View and export HSN sales summary report",
      }
    ],
  },
];
export const initial_state_roles = {
  type: ROLES_TAB,
  label: "Roles",
  allowMultipleTabs: false,
};
export const roleLogsColDefs = [
  {
    headerName: "Role Id",
    field: "roleId",
    maxWidth: 200,
  },
  {
    headerName: "Updated Time",
    field: "created_at",
    maxWidth: 200,
    valueGetter: (params) => {
      return moment(`${params.data.created_at}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  {
    headerName: "Log Details",
    field: "message",
  },
];
export const roleColDefsForExport = [
  {
    headerName: "Role",
    field: "role",
    maxWidth: 200,
  },
  {
    headerName: "Updated Time",
    field: "updatedTime",
    maxWidth: 200,
    valueGetter: (params) => {
      return moment(`${params.data.updatedTime}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  {
    headerName: "Privileges",
    field: "privileges",
  },
];
